import ProductIntro from './product-intro';

export default ProductIntro;
